import React from 'react';
import classNames from 'classnames/bind';
import styles from './Consignment.module.scss';

const cx = classNames.bind(styles);

function Consignment_02() {
	return (
		<div className={cx('terms')}>
			<p>
				매도자는 편리하고 더 나은 서비스를 제공하기 위해 업무 중 일부를 아래의 외부에 위탁하고 있습니다. 개인정보처리 위탁에 동의하지 않는
				경우 계약 체결이 불가합니다.
			</p>
			<dl className={cx('dl_type1')}>
				<dt className={cx('bt0')}>위탁업무내용</dt>
				<dd>홈서비스 요청 차량 탁송</dd>
				<dd>전자 결제 처리</dd>
				<dd>고객상담 시스템 운영/관리</dd>
				<dt className={cx('bt0')}>수탁업체</dt>
				<dd>탁앤카</dd>
				<dd>토스페이먼츠 주식회사</dd>
				<dd>더화이트커뮤니케이션㈜</dd>
				<dt className={cx('bt0')}>보유 및 이용기간</dt>
				<dd className={cx('important')}>목적달성 후 즉시 또는 위탁계약 종료시까지</dd>
				<dd className={cx('important')}>목적달성 후 즉시 또는 위탁계약 종료시까지</dd>
				<dd className={cx('important')}>상담 후 1년 또는 위탁계약 종료시까지</dd>
			</dl>
			<dl className={cx('dl_type2')}>
				<dt>■ 제공 및 변경에 관한 세부 사항</dt>
				<dd>
					엔카닷컴은 위 제휴 업체에게 개인정보를 제공할 경우, 상기한 목적 범위 내에서 제공하며, 위 제공대상 업체 현황, 제공 대상 개인정보
					이용목적, 제공대상 개인정보 항목의 세부적인 내용은 엔카닷컴 홈페이지 (www.encar.com)에서 확인하실 수 있습니다. 엔카닷컴은 위탁하는
					업무의 내용 및 수탁업체 현황의 세부적인 내용은 상기 엔카닷컴 홈페이지에서 확인하실 수 있습니다. 위 사항의 변경이 있을 경우에는 위
					홈페이지에 변경 내용을 게시합니다.
				</dd>
			</dl>
		</div>
	);
}

export default Consignment_02;
